import React from 'react'
import axios from 'axios'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { API_CALL } from '../actions/actionTypes'
import { CopyText } from '../components'

const apiURL = process.env.REACT_APP_REST_EDITOR_API

if (axios && axios.defaults) {
  axios.defaults.withCredentials = true
}

const apiMiddleware = store => next => action => {
  if(action.type === API_CALL) {
    const { apiObject, params, route, options = {}, headers = {} } = action
    const url = route || route === 0 ? `${apiObject.url}/${route}`: apiObject.url
    const method = options.method || apiObject.type
    const body = method === 'get' ? { params } : { data: params }

    // dispatch request action so that reducers can prepare for it
    store.dispatch({
      type: apiObject.request,
      url: `${apiURL}/${url}`,
      method,
      params: params || {},
      route,
      options,
      headers,
    })

    return new Promise((resolve, reject) => axios({
      url,
      method,
      headers,
      ...body,
      withCredentials: true,
    }).then(res => {
      // dispatch success action for reducers with api success constant and result
      store.dispatch({
        type: apiObject.success,
        url,
        method,
        params: params || {},
        payload: res.data,
        response: res,
        route,
        options,
        headers,
      })
      resolve(res.data)
    }).catch(err => {

      const sessionExpired = [401].includes(_.get(err, 'response.status', 0))

      if (sessionExpired) {
        store.dispatch({
          type: 'sessionExpired',
        })
      }

      if (!options.quite && !sessionExpired) {
        const message = _.get(err, 'response.data.error.value') ||
        _.get(err, 'response.data') ||
         'Oops, Something went wrong!'

        toast.error(<CopyText message={message}/>, {
          position: toast.POSITION.TOP_RIGHT,
        })
      }

      store.dispatch({
        type: apiObject.failure,
        url,
        method,
        params: params || {},
        payload: err,
        route,
        options,
        status: _.get(err, 'response.status'),
        headers,
      })
      reject(err)
    }))
  }
  return next(action)
}

export default apiMiddleware
